import style from "./styles/PeriodicExpensesCard.module.css";
import {Badge} from "antd";
import React from "react";


const ActivePayments = ({count}) => {
    return (
        <div className={style.cardFooter}>
            <div className={style.summaryItem}>
                <div>
                    <Badge
                        count={count}
                        color={'green'}
                        className={style.badge}
                    />
                </div>
                <div className={style.summaryLabel}>
                    Активные платежи
                </div>
            </div>
        </div>
    )
}


export default ActivePayments;